var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerge(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.75A.74.74 0 012.75 4H6.5c.531 0 1.063.281 1.375.719l3.406 4.437c.063.063.125.094.188.094h3.969l-1.22-1.219a.684.684 0 010-1.031c.282-.313.75-.313 1.063 0l2.5 2.5a.736.736 0 010 1.031l-2.5 2.5c-.312.313-.781.313-1.062 0a.684.684 0 010-1.031l1.219-1.219h-3.97c-.062 0-.155.031-.187.094l-3.406 4.438A1.702 1.702 0 016.5 16H2.75a.722.722 0 01-.75-.75.74.74 0 01.75-.75H6.5c.063 0 .156-.031.188-.094L10.03 10 6.687 5.625c-.03-.063-.125-.125-.187-.125H2.75A.722.722 0 012 4.75z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default ForwardRef;